var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 58,
    viewBox: "0 0 64 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_489_832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1386 11.073C26.1986 11.073 17.518 17.1241 12.6867 22.3012L3.03837 15.0039C1.69824 13.9897 -0.30258 15.0702 0.0399116 16.6236L2.71135 28.75L0.0388068 40.8775C-0.303685 42.4309 1.69713 43.5103 3.03727 42.4972L12.6856 35.1999C17.5169 40.3759 26.1986 46.427 36.1386 46.427C51.3253 46.427 63.6373 32.2854 63.6373 28.75C63.6373 25.2146 51.3253 11.073 36.1386 11.073ZM45.7979 31.4016C44.3341 31.4016 43.1464 30.2139 43.1464 28.75C43.1464 27.285 44.3341 26.0984 45.7979 26.0984C47.2629 26.0984 48.4495 27.285 48.4495 28.75C48.4495 30.2139 47.2618 31.4016 45.7979 31.4016Z",
    fill: "#D94415"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_489_832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.6372,
    height: 56.5664,
    fill: "white",
    transform: "translate(0 0.466797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish);
export default __webpack_public_path__ + "static/media/fish.abbcea28a623463e299dd2739477773b.svg";
export { ForwardRef as ReactComponent };